/*
 * Notification that an error has occurred
 */
import * as React from "react";

import {BaseToastNotification} from "../base-toast-notification.tsx";

export const ErrorNotification = ({
    content,
}: {
    content: string | React.ReactElement;
}) => {
    return (
        <BaseToastNotification isError={true}>{content}</BaseToastNotification>
    );
};
